import { Config } from "./Config.js";
import { Service } from "./Service.js";
export { ConfigService };
/**
 * REST микросервис, чей URL задан в `config.json`.
 * @author Алексей Васьковский <avaskovskiy@umney.ru>
 */
class ConfigService extends Service {
  /**
   * @param {string} service_name - Имя сервиса.
   */
  constructor(service_name) {
    super(null, service_name);
    this.service_name = service_name;
  }
  /**
   * Асинхронное получение адреса из `config.json`.
   * @returns {string} - Базовый адрес REST микросервиса.
   */
  async getURL() {
    await Config.load();
    return Config.get(this.service_name);
  }
}
